<template>
    <div>
        <div class="loader" v-if="loading" key="loading">Now loading...</div>
        <transition name="loading" mode="out-in">
            <div class="arptable" v-if="!loading">
                <transition name="strans" mode="out-in">
                    <div v-if="!updating">
                        <div class="tablecaption">
                            <span class="tablecaptionvalue">売上合計額： {{ totalAmount | amount }}</span>
                        </div>
                        <table class="salestarget">
                            <thead>
                                <tr>
                                    <th>順位</th>
                                    <th>取引先</th>
                                    <th>売上額</th>
                                    <th>売上構成比</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(did, ix) in datalist" :key="ix">
                                    <td class="">
                                        {{ did.rnk }}
                                    </td>
                                    <td class="text">
                                        <span class="code">{{ did.cust_cd }}</span>
                                        {{ did.cust_nam_s }}
                                    </td>
                                    <td class="amount">
                                        {{ did.sls_amt | amount }}
                                    </td>
                                    <td class="">
                                        {{ did.sls_rate | rate(2) }}
                                    </td>
                                </tr>
                                <tr v-if="!datalist || datalist.length < 1">
                                    <td colspan="4" style="text-align:center;">該当データはありません</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
// import DateUtils from "@/DateUtils";

export default {
    name: "SalesRankingTable",
    props: {
        caption: String,
        fiscalyear: [String, Number],
        perioddiv: Number,
        period: Object,
        refreshcount: Number,
        salesorder_status: Array[String]
    },
    data: function() {
        return {
            datalist: {},
            totalAmount: 0,
            loading: true,
            updating: false,
            datakeys: []
        };
    },
    watch: {
        refreshcount: async function() {
            this.loaddata();
        }
    },
    created: async function() {
        if (this.period) {
            this.loaddata();
        }
        // this.depts = Array.from(this.deptlist);
    },
    methods: {
       
        formatYm: function(ym) {
            let ret = ym.substring(4);
            if (ret.startsWith("0")) {
                ret = ret.substring(1);
            }
            return ret;
        },
        loaddata: async function() {
            this.loading = true;
            const sd = this.period.start;
            const ed = this.period.end;
            const params = [];
            params["period"] = this.dateTo8Str(sd) + "-" + this.dateTo8Str(ed);
            if (this.salesorder_status && this.salesorder_status.length > 0) {
                params["sosts"] = this.salesorder_status;
            }
            return this.readDataToArray(
                this.makeurl("sales-ranking", params),
                (list, _a,_b,_c,_d,data) => {
                    this.datalist = list;
                    this.totalAmount = data.total?? 0;
                    this.loading = false;
                }
            );
        },

    },
    updated: function() {
        this.$nextTick(() => (this.updating = false));
    }
};
</script>

<style scoped>
.arptable {
    position: relative;
    display: inline-block;
}

.arptable table {
    position: relative;
    margin: 0;
    border-collapse: separate;
    border-spacing: 0;
}
.arptable table tr > * {
    border-style: solid none none solid;
    border-width: 1px;
    background-color: var(--main-context-bg-color);
}
.arptable table td {
    text-align: right;
    font-size: 1rem;
    vertical-align: middle;
}
.arptable table td.text {
    text-align: left;
    font-size: 1rem;
    vertical-align: middle;
}
.arptable table th {
    text-align: right;
    font-size: 0.9rem;
    vertical-align: middle;
    background-color: var(--title-bg-color);
    color: var(--title-text-color);
    /* filter: grayscale(50%) brightness(98%); */
}
.arptable table tbody th > .child::before {
    content: " - ";
    padding-right: 0.5rem;
    opacity: 0.25;
}
/* .arptable table tbody tr:last-child th > .child::before {
    content: "└";
} */
/* .arptable table tbody tr.branchDept > * {
    border-top-style: dotted;
    border-bottom-style: dotted;
} */
.tablecaption {
    display: block;
    position: sticky;
    top: 80px;
    left: 0;
    background-color: var(--main-context-bg-color);
    z-index: 4;
    padding: 70px 6em 10px 10px;
    text-align: right;
    margin: 0;
    width: 100%; /* calc(100vw - 18px); */
}
.tablecaptionvalue {
}

.arptable table thead  {
    position: sticky;
    top: 178px;
    /* background-color: #eee; */
    z-index: 2;
}
.arptable table tbody  {
    position: relative;
    /* background-color: #eee; */
    z-index: 1;
}
.arptable table thead tr > th {
    border-bottom-style: solid;
    vertical-align: bottom;
    text-align: center;
}

.arptable thead tr:first-child > *:last-child {
    border-right-style: solid;
    border-right-width: 1px;
    /* position: sticky;
    right: 0; */
}
.arptable tbody tr > *:last-child {
    border-right-width: 1px;
    border-right-style: solid;
}

.arptable tbody tr:last-child > * {
    border-bottom-width: 1px;
    border-bottom-style: solid;
}

.arptable tbody tr:nth-child(2n + 1) > td {
    background: var(--odd-bg-color);
}

.arptable table .slsamt {
    border-left-width: 2px;
}

.arptable table .bene {
    border-right-width: 2px;
}

.arptable table .coltotal {
    border-left-style: double;
    border-left-width: 4px;
    position: sticky;
    right: 0;
}


.arptable .detail {
    /* font-size: 0.75rem; */
    /* opacity: 0.65; */
    /* filter: brightness(95%); */
    /* filter: brightness(95%); */
    font-size: 75%;
    letter-spacing: 1.25px;
}
.arptable th.detail {
    /* opacity: 0.65; */
    /* filter: brightness(95%); */
    /* filter: grayscale(10%) brightness(95%); */
    font-size: 75%;
}


.arptable .amount {
    min-width: 8em;
    width: 8em;
}
.arptable .rate {
    min-width: 4em;
    font-size: 1.1em;
}
.arptable .value {
    height: 1rem;
}
.arptable .logdata {
    height: 1rem;
    opacity: 0.5;
}
.arptable .logdiff {
    height: 1rem;
    opacity: 0.5;
}

.code {
    font-size: 75%;
    color:#999;
}

/* --- */
.year {
    font-size: 75%;
}
/* --- */

.strans-enter-active,
.strans-leave-active {
    /* animation: sizeScale 0.5s ease reverse; */
    transition: 0.25s;
}

.strans-enter,
.strans-leave-to {
    /* animation: sizeScale ease 0.5s; */
    opacity: 0;
}
@keyframes sizeScale {
    100% {
        /* width: 0px; */
        opacity: 0;
    }
}
/* ------------ */
.controlbox {
    padding: 10px;
}
</style>
